import { CashInBankAccount, DashboardSummary } from '@/model/dashboard/dashboard.model';

// Mock data mirroring the dashboard mockup (docs/ui-core-migration-plan.md).

export const DASHBOARD_SUMMARY_FIXTURE: DashboardSummary = {
    till: [
        { cashType: 'Cash on Hand', usd: 1000, khr: 1000000 },
        { cashType: 'Petty Cash', usd: 1000, khr: 1000000 }
    ],
    vault: [
        { currency: 'USD', amount: 1000 },
        { currency: 'KHR', amount: 1000000 }
    ],
    cashInBank: [
        { currency: 'USD', amount: 1000 },
        { currency: 'KHR', amount: 1000000 }
    ],
    total: [
        { currency: 'USD', amount: 1000 },
        { currency: 'KHR', amount: 1000000 }
    ],
    compare: {
        totalYourTill: 25,
        totalVault: 35,
        totalCashInBank: 25,
        percentage: 40
    }
};

export const CASH_IN_BANK_ACCOUNTS_FIXTURE: CashInBankAccount[] = [
    { id: 1, generalLedgerName: 'ABA Bank', usdAmount: 28000, khrAmount: 28000 },
    { id: 2, generalLedgerName: 'ACLEDA Bank', usdAmount: 28000, khrAmount: 28000 },
    { id: 3, generalLedgerName: 'Prince Bank', usdAmount: 28000, khrAmount: 28000 },
    { id: 4, generalLedgerName: 'Vattance Bank', usdAmount: 28000, khrAmount: 28000 },
    { id: 5, generalLedgerName: 'Wing Bank', usdAmount: 28000, khrAmount: 28000 }
];
